import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, Typography } from './../../../../themes/default';
import Dropzone from 'react-dropzone';
import { Modal } from './../../modal'
import { AttachmentService } from './../../../../services';
import { Btn } from './../../../../components/includes/ui';
import { List, ListItem, ListItemText } from './../../../../themes/list';

import API from './../../../../config/api'

const styles = theme => ({
  root: { height: 200, position: 'relative' },
  container: {
    border: `1px solid ${ theme.palette.grey[300] }`,
    padding: theme.spacing.unit,
    borderRadius: theme.spacing.unit / 2
  },
  label: {
    color: theme.palette.grey[700],
    fontSize: 12,
    fontWeight: 600,
    marginBottom: theme.spacing.unit / 2
  },
  zone: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999,
    margin: theme.spacing.unit,
    background: 'rgba(255,255,255,0.8)',
    textAlign: 'center',
    color: theme.palette.common.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px dashed ${ theme.palette.grey[200] }`
  },
  zone__text: theme.typography.display1
});

let dropzoneRef;

class Upload extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      dropzoneRef: null,
      dropzoneActive: true,
      attachments: []
    }
  }

  componentWillReceiveProps(next_props){
    if(next_props.file !== this.props.file){
      let attachment = [next_props.file];
      this.setState({ attachments: attachment });
    }
  }

  /*
  ** @Service
  ** @Description: Find all
  */

  _Upload = (files) => {

    let formData = new FormData();

    files.forEach(file => {
      formData.append('attachment', file, file.name);
    });

    AttachmentService.upload(formData).then((response) => {

      // @Return to component
      this.props.onSuccess(response);

      // @State
      this.setState({
        open: false,
        attachments: response.attachment
      });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  */

  onDragEnter() {}

  /*
  ** @Event
  */

  onDragLeave() {}

  /*
  ** @Event
  */

  onDrop(files) {

    if(files.length > 0){
      this._Upload(files);
    }

  }

  /*
  ** @Event
  */

  onDropRejected(files) {

    this.props.AlertShow({
      open: true,
      variant: 'error',
      message: `We found ${ files.length } file(s) that do not meet the requirements`
    });

  }

  /*
  ** @Event
  */

  onClose() {

    this.props.AtachmentUploadHide({
      open: false
    });

  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleCancel() {
    this.setState({ open: false });
  }

  render() {

    const { classes, button } = this.props;
    const { dropzoneActive, open, attachments } = this.state;

    return(
      <React.Fragment>

        <div className={ classes.container }>

          <Typography classes={{ root: classes.label }}>{ button }</Typography>

          <Btn
            aria-label="Upload"
            color="primary"
            onClick={ this.handleOpen.bind(this) }
            fullWidth
          >
            <span>Upload</span>
          </Btn>

          { (attachments.length > 0) && (
            <List>
              { attachments.map(attachment => {
                return(
                  <ListItem divider disableGutters key={ attachment }>
                    <ListItemText>
                      <Typography component="a" href={`${ API.endpoint.uploads }${ attachment }`} target="_blank">
                        { attachment }
                      </Typography>
                    </ListItemText>
                    {/*
                    <ListItemSecondaryAction>
                      <Btn color="danger" size="xsmall">
                        <CloseIcon fontSize="small"/>
                      </Btn>
                    </ListItemSecondaryAction>
                    */}
                  </ListItem>
                )
              })}
            </List>
          )}

        </div>

        <Modal
            status={ open }
            title={ button ? button : 'Subir contenido' }
            handleCancel={ this.handleCancel.bind(this) }
            maxWidth="sm">

            <Dropzone
              disableClick
              ref={(node) => { dropzoneRef = node; }}
              maxSize={ API.upload.attachment_max_size }
              accept={ API.upload.attachment_available_ext.toString() }
              onDrop={this.onDrop.bind(this)}
              onDragEnter={this.onDragEnter.bind(this)}
              onDragLeave={this.onDragLeave.bind(this)}
              onDropRejected={this.onDropRejected.bind(this)}
              onFileDialogCancel={ this.onClose.bind(this) }
              className={ classes.root }
            >
              { dropzoneActive &&
                <div className={ classes.zone }>
                  <div className={ classNames(classes.zone__container, classes.zone__text ) } >
                    Arrastrar archivos...
                  </div>
                </div>
              }
              <div>
                { this.props.children }
              </div>
            </Dropzone>

        </Modal>

      </React.Fragment>
    )
  }

}

Upload.propTypes = {
  onSuccess: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    AttachmentUpload: state.Upload
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    AtachmentUploadHide: (data) => {
      dispatch({
        type: 'ATTACHMENT_UPLOAD_HIDE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Upload));
